module.exports = __webpack_public_path__ + "static/media/July_2026_1.b0a4651e.webp";